'use client';

import { faHouse } from '@fortawesome/pro-solid-svg-icons/faHouse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Breadcrumb, { BreadcrumbItem } from '@grimme/ui-components/breadcrumb';
import { type ComponentProps } from 'react';
import { Link } from '@/lib/i18n/routing';

export type GrimmeBreadcrumbsProps = {
  breadcrumbs: {
    items: {
      label: string;
      url: string;
    }[];
  };
  variant?: ComponentProps<typeof Breadcrumb>['variant'];
};

export function GrimmeBreadcrumbs({
  breadcrumbs: { items },
  variant,
}: GrimmeBreadcrumbsProps) {
  return (
    <Breadcrumb className="mb-8" variant={variant}>
      <BreadcrumbItem>
        <Link href="/">
          <FontAwesomeIcon icon={faHouse} />
        </Link>
      </BreadcrumbItem>
      {items?.map((item, index) => {
        const isLink = item.url;

        return (
          <BreadcrumbItem active={index === items.length - 1} key={index}>
            {isLink && <Link href={item.url}>{item.label}</Link>}
            {!isLink && item.label}
          </BreadcrumbItem>
        );
      })}
    </Breadcrumb>
  );
}
